var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4999 5.6137L11.5 6.98887C10.7844 6.98887 10.1213 6.7607 9.58007 6.3735V9.16853C9.58007 10.5644 8.44059 11.7 7.04001 11.7C6.49878 11.7 5.99689 11.5299 5.58434 11.2412L5.58363 11.2405C4.92901 10.7821 4.5 10.0244 4.5 9.16824C4.5 7.77241 5.63944 6.63676 7.04007 6.63676C7.15627 6.63676 7.27019 6.6463 7.38237 6.66144L7.38231 8.06578C7.27393 8.03201 7.15942 8.01236 7.04001 8.01236C6.40035 8.01236 5.87998 8.53104 5.87998 9.16853C5.87998 9.61241 6.13269 9.99813 6.50192 10.1918C6.66291 10.2762 6.84576 10.3246 7.03995 10.3246C7.66482 10.3246 8.17459 9.82927 8.19781 9.21201L8.19997 3.70001H9.58002C9.58002 4.78274 10.4725 5.6137 11.4999 5.6137Z",
    fill: "#151419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokCircle);
export default __webpack_public_path__ + "static/media/tiktokCircle.86e4c12e846a8cd6cb6ae70fa1e65984.svg";
export { ForwardRef as ReactComponent };